/**
 * Component load more
 *
 * @module component-load-more
 * @version 1.0.0
 * @extends HTMLElement
 */

import { notifyProductCardsLoaded } from '../utils/product-cards';

 customElements.component = 'component-load-more';

 if (!customElements.get(customElements.component)) {
 
     class componentLoadMore extends HTMLElement {
 
        constructor() {
 
             super();
 
             this.initEvents();
        }
 
        /**
         * Init Events
         * 
         * @return {undefined}
         */
        initEvents() {
            document.querySelectorAll("[data-loadmore-btn]").forEach(button => {
                button.addEventListener('click', event =>{
                    let grid =  document.querySelector("[data-loadmore-grid='"+ event.target.dataset.loadmoreBtn +"']");
                    this.loadMoreProducts(grid, event.target);
                });
            });
        }

        /**
         * Get next page
         * 
         * @param {string} next_url Url for next page.
         * @returns {Promise} Promise object represents a next page.
         */
        getNextPage(next_url) {

            return new Promise((resolve, reject) => {

                fetch(next_url).then(function(response) {
                    return response.text();
                }).then(function(next_page) {
            
                    resolve(next_page);
        
                }).catch(function(error) {
                    console.log(error);
                });
            });
        }

        /**
         * Load products
         * 
         * @param {object} button The grid button.
         * @param {object} grid The grid object.
         */

        loadMoreProducts(grid, button) {

            // Update URL without reload the page
            if(grid.dataset.nextUrl) {
                window.history.pushState('', '', grid.dataset.nextUrl);
            }

            let next_url = grid.dataset.nextUrl;

            button.innerHTML = 'Loading...';
            button.disabled = true;

            this.getNextPage(next_url).then(next_page => {

                let nextPage = next_page;
                const parser = new DOMParser();
                const nextPageDoc = parser.parseFromString(nextPage, 'text/html');       
                const productGrid = nextPageDoc.querySelector("[data-loadmore-grid='"+ button.dataset.loadmoreBtn +"']");
                const new_products = productGrid.querySelectorAll('[data-loadmore-item]');
                const new_url = productGrid.dataset.nextUrl;

                if(new_url) {
                    button.disabled = false;
                    button.innerHTML = 'Load More';
                    grid.dataset.nextUrl = new_url;
                    next_url = new_url;
                }
                else {
                    button.classList.add("hidden");
                }

                for(let i = 0; i < new_products.length; i++) {
                    grid.appendChild(new_products[i]);
                }

                notifyProductCardsLoaded(grid);

            }).catch(function() {
                button.classList.add("hidden");
            });
        }
     }
 
     customElements.define(customElements.component, componentLoadMore);
}
